(function ($) {

  if ($('.woocommerce-notices-wrapper').length && !$('.woocommerce-notices-wrapper').is(':empty')) {
    $('html, body').animate({
      scrollTop: $('.woocommerce-notices-wrapper').offset().top
    }, 1000); 
  }

})(jQuery);